export default {
	state: () => ({
		galleryImagesModalVisible: false,
		galleryImagesModalContent: null,
		galleryImagesModalActiveIndex: 0,
	}),
	getters: {
		getGalleryImagesModalVisible: (state) => {
			return state.galleryImagesModalVisible;
		},
		getGalleryImagesModalContent: (state) => {
			return state.galleryImagesModalContent;
		},
		getGalleryImagesModalActiveIndex: (state) => {
			return state.galleryImagesModalActiveIndex;
		},
	},
	mutations: {
		setGalleryImagesModalVisible: (state, value) => {
			state.galleryImagesModalVisible = value
		},
		setGalleryImagesModalContent: (state, value) => {
			state.galleryImagesModalContent = value
		},
		setGalleryImagesModalActiveIndex: (state, value) => {
			state.galleryImagesModalActiveIndex = value
		},
	}
}

